import { apiClient } from './apiClient'

export const sessionApi = {
    fetchAccessTokenValidity: async (config, authCode) => {
        const f = "fetchAccessTokenValidity()"
        let print = false
        const url = `${config.ssoServiceApiUrl}/accessTokens/${authCode}`
        return await apiClient(
            url,
            null,
            {
                method: "GET"
            },
            async (response) => {
                if (print) {
                    console.log(f.concat(": Received the following response: "))
                    console.log(response)
                }
                return await response.json().then(
                    (obj) => {
                        if (print) {
                            console.log("Inside the fetchAccessTokenValidity promise callback with the following input:")
                            console.log(obj)
                        }
                        return obj.accessToken
                    }
                ).catch(
                    () => {
                        if (print) {
                            console.log(f.concat(": Failed to parse JSON, returning null"))
                        }
                        return null
                    }
                )
            }
        )
    },
    fetchAccessTokenFromAuthCode: async (config, authCode) => {
        const url = `${config.ssoServiceApiUrl}/accessTokens`
        return await apiClient(
            url,
            null,
            {
                method: "POST",
                referrerPolicy: "no-referrer-when-downgrade",
                headers: {
                    'ClientId': '4'
                },
                body: JSON.stringify({
                    "authenticationCode": `${authCode}`,
                    "applicationId": 4,
                    "expires": null,
                    "token": null
                })
            },
            async (response) => {
                return await response.json().then(
                    (obj) => {
                        //console.log("fetchAccessCodeFromAuthCode returned the following:")
                        //console.log(obj)
                        return obj.accessToken
                    }
                )
            }
        )
    },
    refreshSession: async (config, accessToken) => {
        if (!config) {
            throw new Error("config is undefined")
        }
        else if (!accessToken) {
            throw new Error("accessToken is undefined")
        }
        const url = `${config.accountServiceBaseUrl}/api/sessions/${accessToken}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET",
                headers: {
                    'ClientId': '3'
                }
            },
            async (response) => {
                return await response.json().then(
                    (rt) => {
                        return rt.session
                    }
                )
            }
        )
    },
    submitLogout: async (config, accessToken) => {
        const url = `${config.ssoBaseUrl}/logout?clientid=4&redirectToReferer=true`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                redirect: "manual",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: 'logout=logout'
            },
            async (response) => {
                return response.json().then(
                    (result) => {
                        return result.url
                    }
                )
            }
        )
    }
}